import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { EditOutlined } from "@ant-design/icons";

import { Table, Button } from "antd";

import { all as AllCareUnit } from "../../api/CareUnit.js";

const CareUnitTable = forwardRef((props, ref) => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    showSizeChanger: true,
    position: ["topRight"],
  });

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "Nom",
      dataIndex: "name",
      sorter: true,
    },
    {
      title: "Nombre de lits",
      dataIndex: "daily_bed_capacity",
      align: "right",
      sorter: true,
      width: "15%",
    },
    {
      title: "Taux d'occupation non-programmée anticipé",
      dataIndex: "daily_occupancy_rate",
      align: "right",
      render: (data) => {
        return data + "%";
      },
      sorter: true,
    },
    {
      render: (data) => {
        return (
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            size="large"
            onClick={() => props.onEdit(data.id)}
          ></Button>
        );
      },
      width: "30px",
    },
  ];

  let getParams = (pagination, sorter) => {
    let params = {
      current: pagination.current,
      pageSize: pagination.pageSize,
    };

    if (sorter !== undefined && sorter.column !== undefined) {
      let { field, order } = sorter;
      order = (order === 'ascend') ? 1 : -1;

      if (!!field && !!order) {
        params['sort'] = field + "," + order;
      }
    }

    return params;
  };

  let fetch = async function (pagination, filters, sorter) {
    setLoading(true);

    let params = getParams(pagination, sorter);
    AllCareUnit(params)
      .then((data) => {
        setData(data.results);
        setPagination({
          ...pagination,
          total: data.total,
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    fetch(pagination);
  }, []);

  useImperativeHandle(ref, () => ({
    fetch: () => {
      fetch(pagination);
    },
  }));

  return (
    <Table
      columns={columns}
      rowKey={(record) => record.id}
      dataSource={data}
      pagination={pagination}
      loading={loading}
      onChange={fetch}
    />
  );
});

export default CareUnitTable;
